<template>
  <div id="app-news">
    <div class="news-box">
      <div class="news-top">
        <h5>相关新闻</h5>
        <!-- <span @click="gotoNews">更多</span> -->
      </div>
      <div class="news-bottom">
        <ul>
          <li v-for="(item,index) in newsList" :key="index" @click="gotoNewsDetails(item.id)" :title="item.news_title">
            <i></i>
            {{item.news_title}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    newsList: {}
  },
  data() {
    return {
      // newsList: []
    };
  },
  methods: {
    gotoNews() {
      this.$router.push({ path: "/pubIndex", query: { cid: 3 } });
    },
    gotoNewsDetails(id) {
      this.$router.push({ path: "/pubDetails", query: { id: id } });
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
#app-news {
  background-color: #fff;
  margin-top: 15px;
  width: 100%;
  border: solid 1px #eaeaea;
}
.news-box {
  .news-top {
    border-bottom: solid 1px #eaeaea;
    position: relative;
    padding: 20px 0;
    > h5 {
      font-size: 16px;
      color: #333333;
      padding-left: 18px;
    }
    > span {
      cursor: pointer;
      font-size: 14px;
      color: #999999;
      position: absolute;
      right: 23px;
      top: 50%;
      transform: translateY(-50%);
    }
    // }
  }
  .news-bottom {
    padding: 17px 16px 21px 22px;
    > ul {
      > li {
        cursor: pointer;
        list-style: none;
        padding-left: 6px;
        font-size: 12px;
        color: #333333;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分省略号显示*/
        margin-bottom: 15px;
        position: relative;
        &:last-child {
          margin-bottom: 0;
        }
        // >a{
        // color:#333;
        > i {
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background-color: #333;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News/details_news.vue